import axios from 'axios'
import { ElMessage } from 'element-plus'
import config from './config'

// 创建axios实例
const request = axios.create({
    baseURL: config.baseURL, // 使用配置文件中的baseURL
    timeout: config.timeout,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})

// 请求拦截器
request.interceptors.request.use(
    config => {
        // 可以在这里添加token等
        return config
    },
    error => {
        console.error('请求错误:', error)
        return Promise.reject(error)
    }
)

// 响应拦截器
request.interceptors.response.use(
    response => {
        const res = response.data

        // 成功响应
        if (res.code === 200) {
            return res
        }

        // 业务错误
        ElMessage.error(res.msg || '请求失败')
        return Promise.reject(new Error(res.msg || '请求失败'))
    },
    error => {
        console.error('响应错误:', error)

        let message = '网络错误'
        if (error.response) {
            switch (error.response.status) {
                case 400:
                    message = '请求参数错误'
                    break
                case 401:
                    message = '未授权，请重新登录'
                    break
                case 403:
                    message = '拒绝访问'
                    break
                case 404:
                    message = '请求地址不存在'
                    break
                case 500:
                    message = '服务器内部错误'
                    break
                default:
                    message = `连接错误${error.response.status}`
            }
        } else if (error.code === 'ECONNABORTED') {
            message = '请求超时'
        }

        ElMessage.error(message)
        return Promise.reject(error)
    }
)

export default request
